<template>
    <div class="container-fluid">
        <div class="herosection">
            <NavbarSection />
            <img src="../assets/images/sports/bookcourtoverlay.png" alt="overlay" class="overlay-img" />
            <div class="heroWriteup">
                <h2 class="text-white">Book a Court</h2>
                <p>Secure your preferred court with just a few clicks. Whether it’s for a friendly match or serious
                    training.</p>
            </div>
        </div>
        <div class="container">
            <header>
                <h1 id="court-availability">Court Availability</h1>
                <p>Check real-time court availability and book your preferred time slot</p>

                <!-- CURRENT DATE & TIME -->
                <div class="date-time">
                    <strong>{{ currentDate }}</strong> • {{ currentTime }}
                </div>

                <!-- DATE FILTER -->
                <div class="date-filter">
                    <label for="filterDate">Select Date:</label>
                    <input
                        type="date"
                        v-model="selectedDate"
                        :min="minDate"
                        @change="fetchScheduleByDate"
                        onkeydown="return false"
                    />

                </div>

                <div class="legend">
                    <div class="legend-item">
                        <div class="color-box available-color"></div>
                        <span>Available</span>
                    </div>
                    <div class="legend-item">
                        <div class="color-box booked-color"></div>
                        <span>Booked</span>
                    </div>
                    <div class="legend-item">
                        <div class="color-box maintenance-color"></div>
                        <span>Maintenance</span>
                    </div>
                </div>
            </header>

            
            <div class="table table-responsive">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th style="text-align: center;" v-for="court in courts" :key="court.id">
                                {{ court.name }}<br>
                                <span class="court-type">{{ court.description || '' }}</span>
                            </th>
                        </tr>
                    </thead>

                    <tbody v-if="Object.keys(scheduleMap).length">
                    <tr v-for="time in timeSlots" :key="time">
                        <td class="time-column">{{ time }}</td>

                        <template v-for="court in courts" :key="court.id">

                        <!-- REAL CELL -->
                        <td
                            v-if="scheduleMap[time]?.[court.id] && !scheduleMap[time][court.id].hidden"
                            :rowspan="scheduleMap[time][court.id].rowspan || 1"
                            :class="[
                            scheduleMap[time][court.id].status,
                            scheduleMap[time][court.id].rowspan > 1 ? 'merged-cell' : '',
                            !scheduleMap[time][court.id].duration ? 'not-set-cell' : ''
                            ]"
                            @click="handleCellClick(
                                time, 
                                court, 
                                scheduleMap[time][court.id].id,
                                scheduleMap[time][court.id].date
                                )"
                            style="cursor: pointer;"
                        >
                            <!-- BOOKED -->
                            <span v-if="scheduleMap[time][court.id].status === 'booked'">
                            Booked
                            <span class="booked-duration">
                                {{ scheduleMap[time][court.id].duration }}
                            </span>
                            </span>

                            <!-- MAINTENANCE -->
                            <span v-else-if="scheduleMap[time][court.id].status === 'maintenance'">
                            Maintenance
                            </span>

                            <!-- AVAILABLE / NOT SET -->
                            <span v-else>
                            <template v-if="scheduleMap[time][court.id].duration">
                                Available
                                <span class="booked-duration">
                                {{ scheduleMap[time][court.id].duration }}
                                </span>
                            </template>
                            <template v-else>
                                Not available
                            </template>
                            </span>
                        </td>

                        </template>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="modal fade" id="tournamentModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 600px;"> <!-- normal width -->
        <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
            <h5 class="modal-title">Confirm Booking</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body -->
        <form id="tournamentForm">
            <div class="modal-body text-start">
           
                <center><h4>Are you sure you want to book this court?</h4></center>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer">
            <button style="width: 70px;" type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button> &nbsp;
            <button type="button" class="btn btn-success" @click="payWithPaystack()">Yes, I Confirmed.</button>
            </div>
        </form>
        </div>
    </div>
    </div>


</template>

<script setup>
    /* eslint-disable */
    import NavbarSection from '@/components/NavbarSection.vue'
    import { ref, onMounted, onBeforeUnmount } from 'vue'
    import axios from 'axios'
    import router from "@/router";
    import { Modal } from 'bootstrap';
    //import PaystackPop from '@paystack/inline-js';
    
    /* ---------------- STATE ---------------- */
    
    const dataList = ref([])
    const scheduleMap = ref({})
    const loggedId = ref(localStorage.getItem('userid'));

    const firstName = ref('')
    const lastName = ref('')
    const phoneNumber = ref('')
    const emailAddress = ref('')
    const courtId = ref([])
    const bookingTime = ref('')
    const bookingId = ref('')
    const bookingDate = ref('')
    const currentDate = ref('')
    const currentTime = ref('')
    const selectedDate = ref(getTodayDate())
    const minDate = ref(getTodayDate())

    let timer = null
    
    
    /* ---------------- STATIC UI DATA ---------------- */
    
    const timeSlots = ref([
    '6:00','7:00','8:00','9:00','10:00','11:00',
    '12:00','13:00','14:00','15:00',
    '16:00','17:00','18:00','19:00',
    '20:00','21:00','22:00'
    ]);

    
    const courts = ref([])
    
    /* ---------------- HELPERS ---------------- */
    
    const hour = (time) => parseInt(time.split(':')[0])
    
    const formatRange = (start, end) => {
      const s = new Date(`1970-01-01T${start}`)
      const e = new Date(`1970-01-01T${end}`)
      return `${s.getHours()}am - ${e.getHours()}am`
    }
    
    /* ---------------- BUILD GRID ---------------- */
    function updateDateTime () {
        const now = new Date()

        currentDate.value = now.toLocaleDateString('en-GB', {
            weekday: 'long',
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        })

        currentTime.value = now.toLocaleTimeString('en-GB')
    }

    function getTodayDate () {
        return new Date().toISOString().split('T')[0]
    }

    // function fetchScheduleByDate () {
    //     console.log('Fetching schedule for:', selectedDate.value)
    // }

    const buildSchedule = () => {
        scheduleMap.value = {}

        // Initialize all cells as empty (Not set)
        timeSlots.value.forEach(time => {
            scheduleMap.value[time] = {}
            courts.value.forEach(court => {
            scheduleMap.value[time][court.id] = {
                status: 'available',
                rowspan: 1,
                hidden: false,
                duration: null
            }
            })
        })

        // Apply DB records ONLY
        dataList.value.forEach(item => {
        const scheduleId = item.id
        const scheduleDate = item.date

        const startHour = parseInt(item.start_time.split(':')[0])
        const endHour = parseInt(item.end_time.split(':')[0])
        const span = Math.max(endHour - startHour, 1)

        const timeKey = `${startHour}:00`
        if (!scheduleMap.value[timeKey]) return

        scheduleMap.value[timeKey][item.court_id] = {
            id: scheduleId,              // ✅ store ID
            date: scheduleDate,          // ✅ store date
            status: item.status,
            rowspan: span,
            hidden: false,
            duration: `${item.start_time.slice(0,5)} - ${item.end_time.slice(0,5)}`
        }

        // Hide merged rows
        for (let i = 1; i < span; i++) {
            const nextKey = `${startHour + i}:00`
            if (scheduleMap.value[nextKey]) {
            scheduleMap.value[nextKey][item.court_id].hidden = true
            }
        }
        })

    }

    
    /* ---------------- API ---------------- */
    
    const fetchScheduleByDate = async () => {
      try {
        const response = await axios.post('/schedule_court_listing.php', {date: selectedDate.value})
        if (response.data.status) {
          dataList.value = response.data.data
          buildSchedule()
        }
      } catch (error) {
        console.error(error.message)
      }
    }

    const listCourts = async () => {
    try {
        const response = await axios.get('/court_lists.php')

        if (response.data.status) {
        courts.value = response.data.data.map(court => ({
            id: court.id,
            name: court.name,
            description: court.title
        }))
        }
    } catch (error) {
        console.error('Failed to load courts:', error.message)
    }
    }

    
    onMounted(() => {
      listCourts()
      updateDateTime()
      timer = setInterval(updateDateTime, 1000)

      // Load today’s schedule by default
      fetchScheduleByDate()
    })

    onBeforeUnmount(() => {
        clearInterval(timer)
    })

    const handleCellClick = (time, court, id, date) => {
      const cell = scheduleMap.value[time][court.id];
      
      if (cell.status === 'booked') {
        alert(`This court is already booked for ${cell.duration}`);
        // or open a modal with booking details
      } else if (cell.status === 'maintenance') {
        alert(`This court is under maintenance`);
      } else if (cell.duration) { // Available
            if (!loggedId.value) {
                router.push('/login/bookCourt');
                return;
            }

            courtId.value = court
            bookingTime.value = cell.duration
            bookingId.value = id
            bookingDate.value = date

             // open registration modal
            const modal = new Modal(document.getElementById('tournamentModal'));
            modal.show();
        
        //alert(`You can book this court at ${JSON.stringify(cell)}`);
        // open booking modal or trigger booking logic here
      } else { // Not set
        alert(`Court not available`);
      }
    }

    const payWithPaystack = () => {
        createPayment(courtId.value, bookingTime.value, bookingId.value, bookingDate.value)
    }

    const createPayment = async (court, bookingTime, bookingId, bookingDate) => {
    try {
        const response = await axios.post('/book_court.php', {
             courtId: court.id,
             courtName: court.name,
             memberId: loggedId.value,
             firstName: '',
             lastName: '',
             emailAddress: '',
             phoneNumber: '',
             bookingTime: bookingTime,
             bookingDate: bookingDate,
             bookingId: bookingId,
             created_by: loggedId.value,
        });
        if (response.data.status) {
            alert(response.data.message) 
            window.location.reload();
        }
            else console.error(response.data.message);
        } catch (error) {
            console.error(error.message);
        }
    };
    </script>

<style lang="scss" scoped>
/* Make modal look “normal” on small and large screens */
#tournamentModal .modal-dialog {
  width: 100%;        /* take full width on small screens */
  max-width: 600px;   /* normal width on larger screens */
  margin: 1.75rem auto;
  padding: 10px;
}

#tournamentModal .modal-body {
  padding: 1.5rem;
}


.modal-header{
  padding: 1.5rem;
}

.modal-footer {
  padding: 1.5rem;

  button {
    padding: 0.3rem;
  }
}
.form-control{
    padding: 0.5rem;
    margin-right: 4px;
}

.not-set-cell {
  background-color: #f8d7da; /* light red background */
  color: #721c24; /* dark red text */
  text-align: center;
  font-weight: bold;
}

.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/sports/bookcourt.jpg');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 0 4rem;
}
.heroWriteup,
NavbarSection {
    position: relative;
    z-index: 2;
    /* ensures text and navbar appear above overlay */
}

.heroWriteup {
        position: absolute;
        max-width: 650px;
        text-align: left;
        bottom: 15%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 52px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 18px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        button {
            background-color: #F3F4F6;
            width: 296px;
            height: 64px;
            border-radius: 40px;
            border: 4px solid #ED4E241A;
            margin-top: 2rem
        }
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    background: linear-gradient(180deg, rgba(9, 73, 35, 0) 0%, #01170A 100%);
}

.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.5);
    /* black with 40% opacity */
    z-index: 1;
}
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        font-family: Arial, sans-serif;
    }
    
    body {
        padding: 20px;
        background-color: #f5f5f5;
        color: #333;
    }
    
    .container {
        max-width: 1200px;
        margin: 0 auto;
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        padding: 20px;
    }
    
    header {
        margin-bottom: 30px;
    }
    
    h1 {
        color: #2c3e50;
        margin-bottom: 10px;
    }
    
    .legend {
        display: flex;
        gap: 20px;
        margin-top: 15px;
    }
    
    .legend-item {
        display: flex;
        align-items: center;
        gap: 5px;
    }
    
    .color-box {
        width: 15px;
        height: 15px;
        border-radius: 3px;
    }
    
    .available-color {
        background-color: #e8f5e9;
        border: 1px solid #c8e6c9;
    }
    
    .booked-color {
        background-color: #ffebee;
        border: 1px solid #ffcdd2;
    }
    
    .maintenance-color {
        background-color: #fff8e1;
        border: 1px solid #ffecb3;
    }
    
    hr {
        margin: 20px 0;
        border: none;
        border-top: 1px solid #ddd;
    }
    
    h2 {
        color: #2c3e50;
        margin-bottom: 15px;
    }
    
    table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 30px;
    }
    
    th, td {
        padding: 12px 15px;
        text-align: left;
        border: 1px solid #ddd;
    }
    
    th {
        background-color: #f2f2f2;
        font-weight: bold;
    }
    
    .court-type {
        font-size: 12px;
        color: #666;
    }
    
    .time-column {
        width: 80px;
        font-weight: bold;
    }
    
    .available {
        background-color: #e8f5e9;
    }
    
    .booked {
        background-color: #ffebee;
    }
    
    .maintenance {
        background-color: #fff8e1;
    }
    
    .booked-duration {
        font-size: 0.85em;
        color: #c62828;
    }
    
    .merged-cell {
        text-align: center;
    }
        
    @media (max-width: 768px) {
        table {
            font-size: 0.85em;
        }
        
        th, td {
            padding: 8px 10px;
        }

        .heroWriteup {
            width: 100%;
        }
    }
</style>